import { SelectTenant, Settings } from '@xeetr/types/models'
import { Controller, useFormContext } from 'react-hook-form'

import FloatingLabel from '../../components/inputs/FloatingLabel'

import { Input } from '@/components/ui/input'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'

const User = () => {
  const { control, register, watch } = useFormContext<Settings>()
  const tenants = watch('user.tenants')
  const hasMultipleTenants = tenants?.length > 1

  return (
    <div className="space-y-10">
      {/* Account Information */}
      <section>
        <h2 className="mb-1 text-lg font-semibold text-gray-900">Kontoinformationen</h2>
        <p className="mb-6 text-sm text-gray-600">
          Ihre persönlichen Daten und Login-Informationen
        </p>
        <div className="grid grid-cols-1 gap-6 md:grid-cols-4">
          <div className="col-span-4 grid grid-cols-1 gap-6 md:grid-cols-2">
            <FloatingLabel label="E-Mail-Adresse" className="col-span-1">
              <Input {...register('user.mail')} disabled />
            </FloatingLabel>
          </div>
          <Controller
            name="user.firstName"
            control={control}
            render={({ field }) => (
              <FloatingLabel label="Vorname" className="col-span-4 md:col-span-1">
                <Input {...field} />
              </FloatingLabel>
            )}
          />
          <Controller
            name="user.lastName"
            control={control}
            render={({ field }) => (
              <FloatingLabel label="Nachname" className="col-span-4 md:col-span-1">
                <Input {...field} />
              </FloatingLabel>
            )}
          />
        </div>
      </section>

      {/* Default Tenant Selection */}
      {hasMultipleTenants && (
        <section>
          <h2 className="mb-1 text-lg font-semibold text-gray-900">Primäres Unternehmen</h2>
          <p className="mb-6 text-sm text-gray-600">
            Wählen Sie das Unternehmen, das beim Login standardmäßig ausgewählt wird
          </p>
          <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
            <Controller
              name="user.defaultTenant"
              control={control}
              render={({ field }) => (
                <FloatingLabel label="Standard-Unternehmen">
                  <Select value={field.value} onValueChange={field.onChange}>
                    <SelectTrigger>
                      <SelectValue />
                    </SelectTrigger>
                    <SelectContent>
                      {tenants?.map((tenant: SelectTenant) => (
                        <SelectItem key={tenant.tenantId} value={tenant.tenantId}>
                          {tenant.tenantName}
                        </SelectItem>
                      ))}
                    </SelectContent>
                  </Select>
                </FloatingLabel>
              )}
            />
          </div>
        </section>
      )}
    </div>
  )
}

export default User
